var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.4102C2.13493 12.2978 3.66079 11.6747 5.25 11.6747C6.83921 11.6747 8.36507 12.2978 9.5 13.4102C10.6349 14.5227 12.1608 15.1458 13.75 15.1458C15.3392 15.1458 16.8651 14.5227 18 13.4102V2.48166C16.8651 3.5941 15.3392 4.21722 13.75 4.21722C12.1608 4.21722 10.6349 3.5941 9.5 2.48166C8.36507 1.36921 6.83921 0.746094 5.25 0.746094C3.66079 0.746094 2.13493 1.36921 1 2.48166V13.4102ZM1 13.4102V21.9102",
    stroke: "#AA1A5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification1);
export default __webpack_public_path__ + "static/media/notification1.898176e8b53fbbe91b15d97c81c30439.svg";
export { ForwardRef as ReactComponent };